import { logger } from '../logger';

const DEFAULT_API_URL = 'https://api.florentin.dev';

const rawEnvUrl = (import.meta.env.VITE_API_URL ?? DEFAULT_API_URL).replace(/\/+$/, '');
const devProxyPath = import.meta.env.DEV
  ? (import.meta.env.VITE_DEV_API_PROXY ?? '/__api').trim().replace(/\/+$/, '')
  : undefined;
const proxyRewriteDisabled = Boolean(
  import.meta.env.DEV &&
  String(import.meta.env.VITE_DEV_API_PROXY_DISABLE_REWRITE).toLowerCase() === 'true'
);

const isRelativeProxy = Boolean(
  import.meta.env.DEV &&
    devProxyPath &&
    devProxyPath.startsWith('/')
);

export const API_TARGET_URL = rawEnvUrl;
export const USING_DEV_PROXY = isRelativeProxy;
export const API_PROXY_PREFIX = isRelativeProxy ? (devProxyPath || '') : '';
export const API_BASE_URL = isRelativeProxy ? '/' : rawEnvUrl;
export const API_PROXY_DISABLE_REWRITE = proxyRewriteDisabled;

if (import.meta.env.DEV) {
  if (USING_DEV_PROXY) {
    logger.info(
      '[data-source] Using dev API proxy',
      { proxyPrefix: API_PROXY_PREFIX || '/', target: API_TARGET_URL, disableRewrite: proxyRewriteDisabled }
    );
  } else {
    logger.info('[data-source] Using direct API URL', { baseUrl: API_BASE_URL });
  }
}
